import { ReactElement, ReactNode, useMemo } from 'react';
import {
    FetchTasksQuery,
    useEnableTasksSockets,
    useFetchAllTasks
} from '../../queries';
import { useCompanyContext } from '@/companies/providers';
import { UnassignedAlertsContext } from './context';

type UnassignedAlertsProviderProps = {
    readonly children?: ReactNode;
};
export function UnassignedAlertsProvider(
    props: UnassignedAlertsProviderProps
): ReactElement {
    const { children } = props;

    const { company } = useCompanyContext();

    /**
     * Tasks
     */

    useEnableTasksSockets(company.id);

    const query = useMemo(() => {
        const _query: FetchTasksQuery = {
            companyId: company.id,
            liveOnly: true
        };
        return _query;
    }, [company.id]);

    const { tasks: unFilteredTasks, status } = useFetchAllTasks(query);
    const tasks = useMemo(() => {
        return unFilteredTasks
            .filter(
                (task) =>
                    task.simpleStatus === 'ALERTED' &&
                    task.alert &&
                    task.alert.assigned === null
            )
            .sort(
                (a, b) =>
                    new Date(b.startTime).getTime() -
                    new Date(a.startTime).getTime()
            );
    }, [unFilteredTasks]);

    return (
        <UnassignedAlertsContext.Provider
            value={{
                tasks,
                loading: status === 'pending'
            }}
        >
            {children}
        </UnassignedAlertsContext.Provider>
    );
}
